import React, { Component } from 'react';
import { Image, Header, Icon, Button, Statistic, Container } from 'semantic-ui-react'

function ConfirmSeciton(props) {

    const showItem = props.value && props.value !== ''
        ? <div><Statistic color='blue' size='small'>
        <Statistic.Label>{props.category}</Statistic.Label>
        <Statistic.Value>{props.value}</Statistic.Value>
    </Statistic>
    <br /></div>
        : ''

    return (
        // <Header as='h3' icon>
        //     {/* <Icon name={props.icon} /> */}
        //     {props.category}:{props.value}
        //     {/* <Header.Subheader>
        //         Manage your account settings and set e-mail preferences.
        // </Header.Subheader> */}
        // </Header>

        <div>
            {showItem}
            
        </div>
    )
}

function OrderConfirmSection(props) {

    const jerseyNumber = props.order.jerseyNumber
        ? <span>JERSEY NUMBER:{props.order.jerseyNumber}</span>
        : ''

    const teamTypedIn = props.order.typedInTeamName

        ? <div><span><Header sub>TEAM (TYPED IN):{props.order.typedInTeamName}</Header></span>
            <br /></div>
        : ''



    const footballDetails = props.order.teamSelection
        ? <div>
            <span><Header sub>TEAM:{props.order.teamSelection}</Header></span>
            <br />
            {teamTypedIn}
            <span><Header sub>JERSEY NAME:{props.order.jerseyName}</Header></span>
            <br />
            {jerseyNumber}
            <br />
        </div>
        : ''

    return (
        <div>
            <Header sub>{props.orderHeader}</Header>
            {footballDetails}
            {/* <span>Shirt Color:{props.order.shirtColor}</span>
            <br />
            <span>Shirt Size:{props.order.shirtSize}</span>
            <br />
            <span>Shirt Type:{props.order.shirtType}</span>
            <br /> */}
            <span> Qty:{props.order.qty}</span>
            <br />

        </div>
    )
}

export default class NewConfirmOrder extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
    }

    render() {

        const order1 = this.props.newOrderObject.order1
            ? (
                <OrderConfirmSection
                    orderHeader={'Order 1'}
                    order={this.props.newOrderObject.order1} />

            )
            : (<br />)

        const order2 = this.props.newOrderObject.order2
            ? (
                <OrderConfirmSection
                    orderHeader={'Order 2'}
                    order={this.props.newOrderObject.order2} />

            )
            : (<br />)

        const order3 = this.props.newOrderObject.order3
            ? (
                <OrderConfirmSection
                    orderHeader={'Order 3'}
                    order={this.props.newOrderObject.order3} />

            )
            : (<br />)


        const singleOrders = this.props.singleOrderArray.map((order, index) =>
            <OrderConfirmSection
                orderHeader={'Order ' + (index + 1)}
                order={order} />
        )

        return (
            this.props.orderConfirming
                ? <div>
                    <Container text textAlign='center'>
                        <Image src={require('./img/printbodalogo_large.png')} />
                        <Header as='h2' color='blue' textAlign='center'>
                            {' '} Confirm Your Order
                        </Header>

                        {/* TEXT ON SHIRT */}
                        <ConfirmSeciton
                            icon='settings'
                            category='Words On Shirt'
                            value={this.props.newOrderObject.shirtText} />

                        {/* TEXT ON BACK SHIRT */}
                        <ConfirmSeciton
                            icon='settings'
                            category='Words On Back Of Shirt'
                            value={this.props.newOrderObject.shirtBackText} />

                        {/* TOTAL SHIRTS */}
                        <ConfirmSeciton
                            icon='settings'
                            category='Total Number of Items'
                            value={this.props.newOrderObject.totalShirts} />

                        {/* NUM ORDERS */}
                        <ConfirmSeciton
                            icon='settings'
                            category='Orders'
                            value={this.props.newOrderObject.numOrders} />

                        {/* QUANTITY*/}
                        {/* <ConfirmSeciton
                            icon='settings'
                            category='Quantity'
                            value={this.props.newOrderObject.quantity} /> */}

                        {/* SHIRT SIZE */}
                        {/* <ConfirmSeciton
                            icon='settings'
                            category='shirt size'
                            value={this.props.newOrderObject.shirtSize} /> */}

                        {/* CONFIRM THE ORDER SECTIONS */}
                        {/* {order1}
                        {order2}
                        {order3} */}
                        {singleOrders}

                        {/* NAME */}
                        <ConfirmSeciton
                            icon='settings'
                            category='Name'
                            value={this.props.newOrderObject.name} />

                        {/* PHONE */}
                        <ConfirmSeciton
                            icon='settings'
                            category='Phone'
                            value={this.props.newOrderObject.phone} />

                        {/* PHONE */}
                        <ConfirmSeciton
                            icon='settings'
                            category='Phone #2'
                            value={this.props.newOrderObject.phone2} />

                        {/* ADDRESS  */}
                        <ConfirmSeciton
                            icon='settings'
                            category='Address'
                            value={this.props.newOrderObject.address} />

                        {/* EMAIL  */}
                        <ConfirmSeciton
                            icon='settings'
                            category='Email'
                            value={this.props.newOrderObject.email} />

                        {/* SHIRT TYPES
                        <ConfirmSeciton
                            icon='settings'
                            category='Shirt Type'
                            value={this.props.newOrderObject.shirtType} /> */}


                        {/* SPECIAL INSTRUCTIONS  */}
                        <ConfirmSeciton
                            icon='settings'
                            category='Special Instructions'
                            value={this.props.newOrderObject.special_instructions} />

                        <Button onClick={this.props.saveOrder} color='blue' fluid size='large'>CONFIRM</Button>
                        <p></p>
                        <Button onClick={this.props.changeOrder} type='purple' color='red' fluid size='large'>CHANGE</Button>
                    </Container>
                </div>
                : <h6></h6>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/newSite/NewConfirmOrder.js